import { Image, ImageProps } from 'theme-ui'

const Ethena = (props: ImageProps) => {
  return <Image width={16} src="/svgs/ethena.svg" {...props} />
}
export default Ethena
